import { render, staticRenderFns } from "./pdi-plan-list.component.vue?vue&type=template&id=201eb62b&scoped=true&"
import script from "./pdi-plan-list.component.vue?vue&type=script&lang=ts&"
export * from "./pdi-plan-list.component.vue?vue&type=script&lang=ts&"
import style0 from "./pdi-plan-list.component.vue?vue&type=style&index=0&id=201eb62b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201eb62b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VExpandTransition,VIcon,VRow})
